export const modWith10Divisor = (number) => number % 10;
export const modWith100Divisor = (number) => number % 100;
